// reducers/core/index.js

import { combineReducers }  from 'redux';
import { page }             from './pages';
import { pageHasErrored }   from './pages';
import { pageIsLoading }    from './pages';
import { ribbon }           from './ribbon';
import { ribbonHasErrored } from './ribbon';
import { ribbonIsLoading }  from './ribbon';

const pageReducers = combineReducers({
  page,
  pageHasErrored,
  pageIsLoading
});

const ribbonReducers = combineReducers({
  ribbon,
  ribbonHasErrored,
  ribbonIsLoading
});

export default combineReducers({
  pages: pageReducers,
  ribbon: ribbonReducers
});